import React from 'react'
import { FiSearch } from "react-icons/fi";

const Input = ({ type = "text", placeholder, value, onChange }) => {
    return (
        <div className="relative border flex items-center space-x-2 p-4 py-2 rounded-md md:w-fit w-full">
            <FiSearch />
            <input
                type={type}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                className="  bg-[#DFE6F61A] border-[#E9E9E9] font-normal  rounded-md  lg:w-48 md:w-52 w-full outline-none ring-0   "
            />
        </div>

    )
}

export default Input